__turbopack_context__.v({
  "black-bt": "SelectDropdown-module-scss-module__IzAGuW__black-bt",
  "btnCustom": "SelectDropdown-module-scss-module__IzAGuW__btnCustom",
  "chooseCountry": "SelectDropdown-module-scss-module__IzAGuW__chooseCountry",
  "customCountryGroup": "SelectDropdown-module-scss-module__IzAGuW__customCountryGroup",
  "flag": "SelectDropdown-module-scss-module__IzAGuW__flag",
  "flagBlock": "SelectDropdown-module-scss-module__IzAGuW__flagBlock",
  "formGroup": "SelectDropdown-module-scss-module__IzAGuW__formGroup",
  "label": "SelectDropdown-module-scss-module__IzAGuW__label",
  "pd_5": "SelectDropdown-module-scss-module__IzAGuW__pd_5",
  "selectCountry": "SelectDropdown-module-scss-module__IzAGuW__selectCountry",
  "selectCountryCustom": "SelectDropdown-module-scss-module__IzAGuW__selectCountryCustom",
  "userIcon": "SelectDropdown-module-scss-module__IzAGuW__userIcon",
  "userIconBlock": "SelectDropdown-module-scss-module__IzAGuW__userIconBlock",
});
